// Dialoog van de verplichte 2FA-setup: QR-code, handmatige sleutel en codeveld.
import React from 'react';
import {
  Box,
  Typography,
  Button,
  Alert,
  CircularProgress,
  Stack,
  Divider,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { QrCode, CheckCircle } from '@mui/icons-material';

export default function MandatoryTwoFactorSetupDialog({
  open,
  qrCodeUrl,
  secret,
  verifyCode,
  setVerifyCode,
  error,
  loading,
  onVerify,
}) {
  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: { borderRadius: 3 },
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Stack
          direction="column"
          spacing={1}
          sx={{
            alignItems: 'center',
          }}
        >
          <QrCode color="primary" sx={{ fontSize: 40 }} />
          <Typography variant="h6">Verplichte 2FA Setup</Typography>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={3}>
          <Alert severity="info" sx={{ borderRadius: 2 }}>
            Scan de QR code met je authenticator app en voer de 6-cijferige code in om de setup te
            voltooien.
          </Alert>

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="subtitle2" sx={{ mb: 2 }}>
              Scan deze QR code:
            </Typography>
            {qrCodeUrl && (
              <Box
                component="img"
                src={qrCodeUrl}
                alt="2FA QR Code"
                sx={{
                  maxWidth: '100%',
                  height: 'auto',
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 2,
                  p: 2,
                  bgcolor: 'background.paper',
                }}
              />
            )}
          </Box>

          <Divider />

          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Of voer deze code handmatig in:
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontFamily: 'monospace',
                fontSize: '0.85rem',
                p: 1,
                bgcolor: 'action.hover',
                borderRadius: 1,
                wordBreak: 'break-all',
              }}
            >
              {secret}
            </Typography>
          </Box>

          <TextField
            fullWidth
            label="Verificatie code (6 cijfers)"
            value={verifyCode}
            onChange={(e) => setVerifyCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            placeholder="123456"
            helperText="Voer de 6-cijferige code uit je authenticator app in"
            slotProps={{
              htmlInput: {
                maxLength: 6,
                inputMode: 'numeric',
                autoComplete: 'one-time-code',
                style: { textAlign: 'center', fontSize: '1.2rem', letterSpacing: '0.3em' },
              },
            }}
          />

          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button
          onClick={onVerify}
          variant="contained"
          fullWidth
          disabled={loading || verifyCode.length !== 6}
          startIcon={loading ? <CircularProgress size={16} /> : <CheckCircle />}
          sx={{ py: 1.5 }}
        >
          {loading ? 'Verificeren...' : 'Setup Voltooien'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
